const ProfileScreenTeacherPortal = ({
  userData,
  phone,
  address,
  updateProfile,
  setPhone,
  setAddress,
  calendarSync = {},
}) => {
  const {
    status,
    statusLabel,
    statusError,
    statusLoading,
    banner,
    connectLoading,
    disconnectLoading,
    onConnect,
    onDisconnect,
    onRefresh,
  } = calendarSync || {};

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/teacherportal";
  }

  const shouldShowCalendarSync =
    (userData?.School || "").toLowerCase() === "mor" || (userData?.School || "").toLowerCase() === "psma" || (userData?.School || "").toLowerCase() === "lsma" || (userData?.School || "").toLowerCase() === "tma" || (userData?.School || "").toLowerCase() === "mma";

  return (
    <div className="new-teacher-portal__profile">
      <section className="teacher-profile__hero">
        <div className="teacher-profile__hero-photo">
          <img
            className="new-teacher-portal__teacher-image"
            alt="teacher-pic"
            src={`https://app.atharo.app/images/${userData.ImageName}`}
          />
        </div>
        <div>
          <div className="teacher-profile__hero-name">{userData.Name}</div>
          <div className="teacher-profile__hero-role">Music Teacher</div>
        </div>
      </section>
      <div className="teacher-profile__content">
        <section className="teacher-profile__card">
          <div className="teacher-profile__card-header">
            <div className="teacher-profile__card-title">Contact Information</div>
            <p className="teacher-profile__card-subtitle">
              Keep your phone and address current so families can reach you.
            </p>
          </div>
          <div className="teacher-profile__form-grid">
            <div className="teacher-profile__field">
              <label className="teacher-profile__label">Phone Number</label>
              <input
                className="teacher-profile__input"
                id="new-teacher-portal__phone"
                value={phone}
                onBlur={(e) =>
                  (document.getElementById(e.target.id).style.outline = "none")
                }
                onChange={(e) =>
                  updateProfile(
                    e.target.value,
                    setPhone,
                    "new-teacher-portal__phone",
                    false
                  )
                }
              />
            </div>
            <div className="teacher-profile__field">
              <label className="teacher-profile__label">Street Address</label>
              <input
                className="teacher-profile__input"
                id="new-teacher-portal__street"
                value={address.StreetAddress}
                onBlur={(e) =>
                  (document.getElementById(e.target.id).style.outline = "none")
                }
                onChange={(e) =>
                  updateProfile(
                    e.target.value,
                    setAddress,
                    "new-teacher-portal__street",
                    "StreetAddress"
                  )
                }
              />
            </div>
            <div className="teacher-profile__field teacher-profile__field--half">
              <label className="teacher-profile__label">City</label>
              <input
                className="teacher-profile__input"
                id="new-teacher-portal__city"
                value={address.City}
                onBlur={(e) =>
                  (document.getElementById(e.target.id).style.outline = "none")
                }
                onChange={(e) =>
                  updateProfile(
                    e.target.value,
                    setAddress,
                    "new-teacher-portal__city",
                    "City"
                  )
                }
              />
            </div>
            <div className="teacher-profile__field teacher-profile__field--quarter">
              <label className="teacher-profile__label">State</label>
              <input
                className="teacher-profile__input"
                id="new-teacher-portal__state"
                value={address.State}
                onBlur={(e) =>
                  (document.getElementById(e.target.id).style.outline = "none")
                }
                onChange={(e) =>
                  updateProfile(
                    e.target.value,
                    setAddress,
                    "new-teacher-portal__state",
                    "State"
                  )
                }
              />
            </div>
            <div className="teacher-profile__field teacher-profile__field--quarter">
              <label className="teacher-profile__label">Zip Code</label>
              <input
                className="teacher-profile__input"
                id="new-teacher-portal__zip"
                value={address.Zip}
                onBlur={(e) =>
                  (document.getElementById(e.target.id).style.outline = "none")
                }
                onChange={(e) =>
                  updateProfile(
                    e.target.value,
                    setAddress,
                    "new-teacher-portal__zip",
                    "Zip"
                  )
                }
              />
            </div>
          </div>
        </section>
        {shouldShowCalendarSync && (
          <section
            className={`teacher-profile__card teacher-profile__card--calendar new-teacher-portal__calendar-card ${
              status?.connected ? "is-connected" : ""
            }`}
          >
            {status?.connected ? (
              <div className="new-teacher-portal__calendar-connected-summary">
                <span className="new-teacher-portal__calendar-pill is-connected">
                  Connected
                </span>
                <div className="new-teacher-portal__calendar-connected-text">
                  Google Calendar Synced as{" "}
                  <span>
                    {status?.email || userData?.Email || "your account"}
                  </span>
                </div>
              </div>
            ) : (
              <>
                <div className="teacher-profile__card-header">
                  <div>
                    <div className="teacher-profile__card-title">
                      Google Calendar Sync
                    </div>
                    <p className="teacher-profile__card-subtitle">
                      Connect your lessons to Google Calendar so new bookings and
                      changes show up instantly.
                    </p>
                  </div>
                  <span
                    className={`new-teacher-portal__calendar-pill ${
                      status?.connected ? "is-connected" : "is-disconnected"
                    }`}
                  >
                    {status?.connected ? "Connected" : "Not Connected"}
                  </span>
                </div>
                {banner && (
                  <div
                    className={`new-teacher-portal__calendar-banner is-${banner.type}`}
                  >
                    {banner.message}
                  </div>
                )}
                <p className="new-teacher-portal__calendar-status">
                  {statusLabel}
                </p>
                {statusError && (
                  <div className="new-teacher-portal__calendar-error">
                    {statusError}
                  </div>
                )}
                <div className="new-teacher-portal__calendar-actions">
                  <button
                    type="button"
                    className="new-teacher-portal__calendar-button is-primary"
                    onClick={() => onConnect && onConnect()}
                    disabled={connectLoading || statusLoading}
                  >
                    {connectLoading ? "Redirecting…" : "Sync Google Calendar"}
                  </button>
                  <button
                    type="button"
                    className="new-teacher-portal__calendar-button is-outline"
                    onClick={() => onRefresh && onRefresh()}
                    disabled={statusLoading}
                  >
                    {statusLoading ? "Refreshing…" : "Refresh Status"}
                  </button>
                </div>
              </>
            )}
          </section>
        )}
        <section className="teacher-profile__card teacher-profile__card--logout">
          <div>
            <div className="teacher-profile__card-title">Sign out</div>
            <p className="teacher-profile__card-subtitle">
              Log out if you are finished or using a shared device.
            </p>
          </div>
          <button
            type="button"
            className="teacher-profile__logout-button"
            onClick={logOut}
          >
            Logout
          </button>
        </section>
      </div>
    </div>
  );
};
export default ProfileScreenTeacherPortal;
